import React from 'react'

function NoVenueStatusBanner() {
  return (
    <div style={{ marginTop: '12px' }}>
      <div className="flex justify-center">
        <div className="shrink mr-[8px] content-center justify-center">
          <img className="w-[14px] h-[11px]" src="/VenueStatus/purple_crown.svg" />
        </div>
        <div className="shrink">
          <span className="text-[13px] text-white tracking-tighter">Open a Mobile check to earn points on every purchase</span>
        </div>
      </div>
    </div>
  )
}

export default NoVenueStatusBanner
